import classNames from 'classnames';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { PAIR_PAGE_TYPE } from '@/constants/global';
import { TRADE_OVERLAY_TYPE, TRADE_TYPE } from '@/constants/trade';
import { resetLiquidityFormByChainId } from '@/features/earn/action';
import { useCurrentMarketType } from '@/features/global/hooks';
import { useTradeType } from '@/features/trade/hooks';
import { useTradeStore } from '@/features/trade/store';
import { useAppDispatch } from '@/hooks';
import './index.less';

interface ClosePositionLinkProps {
  chainId: number | undefined;
  pairSymbol: string | undefined;
}

const ClosePositionLink: FC<ClosePositionLinkProps> = ({ chainId, pairSymbol }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const tradeType = useTradeType(chainId);

  const { setShowTradeAreaOverlay, setClosePositionPairSymbol } = useTradeStore();
  const pageTye = useCurrentMarketType();
  const closePosition = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (!pairSymbol) {
        return;
      }
      // pairPageNavigate(pairSymbol, PAIR_PAGE_TYPE.TRADE, chainId, { state: { toClose: true } });
      if (tradeType !== TRADE_TYPE.CLOSE_POSITION) {
        setClosePositionPairSymbol(pairSymbol);
        setShowTradeAreaOverlay(TRADE_OVERLAY_TYPE.CLOSE_POSITION);
        if (pageTye === PAIR_PAGE_TYPE.EARN) {
          chainId && dispatch(resetLiquidityFormByChainId({ chainId }));
        }
      }
    },
    [chainId, dispatch, pageTye, pairSymbol, setShowTradeAreaOverlay, tradeType, setClosePositionPairSymbol],
  );

  return (
    <a
      className={classNames('syn-close-position-link', tradeType === TRADE_TYPE.CLOSE_POSITION && 'syn-btn-active')}
      onClick={closePosition}>
      {t('common.close')}
    </a>
  );
};

export default ClosePositionLink;
